import { StyleSheet } from 'aphrodite';
import { brandPrimary, mention, white } from '../../../../../web/styles/colors';
import { BreakPoints } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	body: {
		background: white,
		textAlign: 'center',
		[BreakPoints.phoneCompactWidth]: {
			borderRadius: 0,
		},
		minHeight: '75vh',
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
	},
	container: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh',
	},
	content: {
		margin: '0 auto',
		width: '100%',
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		[BreakPoints.forMinWidth(768)]: {
			boxShadow: `0 0 6px 0 rgba(139,139,139,0.10)`,
			width: '100%',
			paddingTop: 0,
		},
	},
	footer: {
		alignItems: 'center',
		color: white,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 12,
		justifyContent: 'center',
		background: white,
		flexShrink: 0,
		marginTop: -1,
		paddingTop: 16,
		paddingBottom: 16,
	},
	mainLogo: {
		width: 158,
	},
	poweredBy: {
		marginBottom: 8,
		color: brandPrimary,
		fontWeight: 600,
	},
	headerEvent: {
		backgroundColor: '#f9f9f9',
		flexShrink: 0,
	},
	headerSatisfaction: {
		color: brandPrimary,
		backgroundColor: mention,
		minHeight: 125,
		flexShrink: 0,
	},
	customHeader: {
		flexShrink: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: '100%',
	},
	customFooter: {
		flexShrink: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: '100%',
	},
});
